import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { auth, db } from "./firebase";
import { Element, scroller } from "react-scroll";
import firebase from "firebase/compat/app";
import IncidentResponsePlan from "./IncidentResponsePlan";
import DisasterRecoveryChecklist from "./DisasterRecoveryChecklist";

const Chapter4_5 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Was ist das Hauptziel eines Disaster-Recovery-Plans (DRP)?",
      options: [
        {
          value: "A",
          label:
            "Die Überwachung von Netzwerkaktivitäten zur Erkennung von Sicherheitsvorfällen.",
        },
        {
          value: "B",
          label:
            "Die Wiederherstellung von IT-Systemen und Daten nach einem größeren Ausfall.",
        },
      ],
      correct: "B",
    },
    {
      question: "Frage 2: Was gehört zur Incident Response (IR)?",
      options: [
        {
          value: "A",
          label:
            "Die schnelle Eindämmung und Analyse eines Sicherheitsvorfalls.",
        },
        {
          value: "B",
          label:
            "Die langfristige Wiederherstellung von Infrastruktur nach einem Systemausfall.",
        },
      ],
      correct: "A",
    },
  ];
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      scroller.scrollTo(location.hash.substring(1), {
        duration: 500,
        smooth: true,
        offset: -50,
      });
    }
  }, [location]);

  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

   
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 4_5.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
       
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

       
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "4_5",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("4_5"),
            });
          console.log("Dokument aktualisiert mit Kapitel 4_5.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "4_5",
              completedChapters: ["4_5"],
            });
          console.log("Dokument erstellt mit Kapitel 4_5");
        }

        navigate("/5_1"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  4. Netzwerk und Netzwerksicherheit
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Incident Response und Disaster Recovery
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-3">
            Kapitel 4: Netzwerk und Netzwerksicherheit
          </h3>
          <h2 className="text-center p-3">
            Incident Response und Disaster Recovery
          </h2>
          <img
            src="/images/disaster2.webp"
            alt="disaster"
            style={{ position: "relative", maxWidth: "15%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <h2 className="p-5">
            Vorfall- und Wiederherstellungsmanagement in Netzwerken
          </h2>
          <p className="col-lg-11 mx-auto">
            Angesichts wachsender Cyberbedrohungen ist es nicht die Frage ob,
            sondern wann ein Unternehmen mit einem Sicherheitsvorfall
            konfrontiert wird. Unternehmen müssen nicht nur in der Lage sein,
            Sicherheitsvorfälle schnell zu erkennen, sondern auch effiziente
            Maßnahmen zur Wiederherstellung schaffen, um die
            Geschäftskontinuität und Datenintegrität zu gewährleisten.
            <br />
            <br />
            Ein robustes Vorfall- und Wiederherstellungsmanagement hilft dabei
            mit zwei zentralen Konzepten:
            <br /> <strong>Incident Response (IR)</strong> und{" "}
            <strong>Disaster Recovery (DR).</strong>
            <br /> <br />
            IR und DR sind keine voneinander getrennten Prozesse – sie ergänzen
            sich. Während das Incident Response (übersetzbar mit
            Vorfallmanagement) den akuten Vorfall bewältigt, sorgt das Disaster
            Recovery (übersetzbar mit Notfallwiederherstellung) dafür, dass das
            Unternehmen langfristig handlungsfähig bleibt.
            <br />
            <br />
            Wenn z. B. ein Server wird durch Malware infiziert wird, wird im
            IR-Prozess der Server isoliert, bereinigt und anschließend wieder in
            Betrieb genommen. Wenn aber z. B. ein ganzes Rechenzentrum durch
            einen Brand zerstört wird, greift das DR durch Backups um alle Daten
            und Systeme auf einer <strong>Ersatzinfrastruktur </strong>
            wiederherzustellen.
            <br />
            <br />
            Gemeinsam bilden das IR und DR das Fundament für eine umfassende{" "}
            <strong>Business Resilience. </strong> Business Resilience
            beschreibt die Fähigkeit eines Unternehmens, trotz Störungen, Krisen
            oder Katastrophen (z. B. Cyberangriffe, Naturkatastrophen,
            wirtschaftliche Herausforderungen) weiterhin zu funktionieren, sich
            anzupassen und schnell wieder den Normalbetrieb aufzunehmen.
          </p>
          <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
            <img
              src="/images/fact.svg"
              alt="Transparent"
              style={{
                position: "relative",
                maxWidth: "8%",
                height: "auto",
              }}
            />
            Unternehmen brauchen durchschnittlich 241 Tage, um einen
            Sicherheitsvorfall zu erkennen, einzudämmen und den Zustand vor dem
            Angriff wieder herzustellen - 181 Tage bis zur Entdeckung und 60 Tage bis zur Eindämmung. (IBM Cost of a Data Breach Report 2025)
          </p>
        </div>
        <div className="grey-section">
          <div className="container">
            <div className="p-5 text-center">
              <Element name="ir">
                <h2 className="p-5">Incident Response</h2>
                <p>
                  Ein gut ausgearbeitetes Incident-Response hilft, auf
                  Sicherheitsvorfälle wie Cyberangriffe oder Datenlecks
                  strukturiert und effizient zu reagieren. Ziel ist es, den
                  Schaden zu minimieren, den Vorfall einzudämmen und die
                  Geschäftsprozesse schnellstmöglich wiederherzustellen.
                  <br /> <br />
                  Die Phasen des Incident Response: <br /> <br />
                  <section class="p-5 text-start">
                    <ul class="timeline">
                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">1. Vorbereitung (Preparation): </h5>

                        <p>
                          <ul>
                            <li>
                              Erstellung eines Incident-Response-Teams (IRT) mit
                              definierten Rollen und Zuständigkeiten
                            </li>
                            <li>Schulung von Mitarbeitern</li>
                            <li>
                              Implementierung geeigneter Sicherheitswerkzeuge
                              und -maßnahmen wie Firewall, Anti-Viren-Software
                              usw.
                            </li>
                          </ul>
                        </p>
                      </li>

                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">
                          2. Erkennung und Analyse (Detection and Analysis):
                        </h5>

                        <p>
                          <ul>
                            <li>Überwachung von Systemen und Netzwerken</li>
                            <li>
                              Einsatz von{" "}
                              <Link to="/4_3#ids" className="icon-link">
                                <svg className="bi" aria-hidden="true">
                                  <use xlinkHref="#book"></use>
                                </svg>{" "}
                                Intrusion Detection Systems (IDS)
                              </Link>{" "}
                              und{" "}
                              <Link to="/4_3#siem" className="icon-link">
                                <svg className="bi" aria-hidden="true">
                                  <use xlinkHref="#book"></use>
                                </svg>{" "}
                                Security Information and Event Management (SIEM)
                              </Link>{" "}
                            </li>
                            <li>Analyse von Warnmeldungen und Anomalien</li>
                          </ul>
                        </p>
                      </li>

                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">3. Eindämmung (Containment):</h5>

                        <p>
                          <ul>
                            <li>
                              Schnelle Bewertung der Situation (welche Systeme,
                              Daten und Netzwerke sind betroffen){" "}
                            </li>
                            <li>
                              Isolierung der Bedrohung (Trennen der betroffenen
                              Systeme vom Netzwerk, um die weitere Verbreitung
                              von Malware oder Angreifern zu stoppen.)
                            </li>
                            <li>
                              Kurzfristige Maßnahmen (Abschalten von infizierten
                              Geräten, Blockieren von IP-Adressen oder Ports,
                              Deaktivierung von kompromittierten Systemen)
                            </li>
                            <li>
                              Sichern von Beweismaterial (Sammeln von Logs,
                              Speicherabbildern (Memory Dumps) oder anderen
                              forensischen Daten, bevor Änderungen vorgenommen
                              werden. Diese Beweise helfen bei der Untersuchung
                              und Analyse des Vorfalls.)
                            </li>
                          </ul>
                        </p>
                      </li>

                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">4. Behebung (Eradication): </h5>

                        <p>
                          <ul>
                            <li>
                              Identifikation der Ursache (Analyse, wie der
                              Vorfall zustande kam)
                            </li>
                            <li>
                              Entfernung der Bedrohung (Beseitigung von Malware
                              oder kompromittierten Daten)
                            </li>
                            <li>Patch und Absicherung von Schwachstellen</li>
                            <li>
                              Prüfung des Systems (sind keine Hintertüren oder
                              versteckte Malware verblieben)
                            </li>
                            <li>Kommunikation mit den Betroffenen</li>
                          </ul>
                        </p>
                      </li>

                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">
                          5. Wiederherstellung (Recovery):
                        </h5>

                        <p>
                          <ul>
                            <li>
                              Systemwiederherstellung (Wiederherstellung aus
                              sicheren Backups)
                            </li>
                            <li>
                              Systemhärtung (Implementierung zusätzlicher
                              Sicherheitsmaßnahmen um erneuten Angriff
                              auszuschließen){" "}
                            </li>
                            <li>
                              Überprüfung der Systeme auf Sicherheit und
                              Stabilität
                            </li>
                            <li>Schrittweise Rückkehr zum Normalbetrieb</li>

                            <li>Monitoring zur Prävention erneuter Angriffe</li>
                            <li>Kommunikation über die Wiederherstellung</li>
                          </ul>
                        </p>
                      </li>

                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">
                          6. Nachbereitung (Lessons Learned):{" "}
                        </h5>

                        <p>
                          <ul>
                            <li>Detaillierte Analyse des Vorfalls</li>
                            <li>
                              Identifizieren von Schwachstellen und
                              Verbesserungspotenzialen
                            </li>
                            <li>Aktualisierung von Incident-Response-Plänen</li>
                          </ul>
                        </p>
                      </li>
                    </ul>
                  </section>
                </p>
              </Element>
              <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                <img
                  src="/images/fact.svg"
                  alt="Transparent"
                  style={{
                    position: "relative",
                    maxWidth: "8%",
                    height: "auto",
                  }}
                />
                Die Position des Incident-Response-Analysten ist eine der
                gefragtesten Positionen im Bereich Cybersecurity. Ein
                Incident-Response-Analyst verwendet spezialisierte Tools und
                arbeitet oft unter Zeitdruck, um Vorfälle schnell zu lösen. Die
                hohe Nachfrage nach diesen Fähigkeiten macht Incident Response
                zu einem sehr gefragten Karriereweg im Bereich der
                IT-Sicherheit.
              </p>
            </div>
          </div>
        </div>

        <div className="white-section">
          <div className="container">
            <div className="p-5 text-center">
              <Element name="dr">
                <h2 className="p-5">Disaster Recovery</h2>
                <p>
                  Während Incident Response bei akuten Sicherheitsvorfälle zum
                  Einsatz kommt, konzentriert sich Disaster Recovery auf die
                  Wiederherstellung von IT-Systemen und Daten nach einem
                  größeren Ausfall, z. B. durch massive Cyberangriffe,
                  Hardwaredefekte oder Naturkatastrophen.
                  <br /> <br />
                  Wichtige Bausteine eines Disaster-Recovery-Plans: <br />{" "}
                  <br />
                  <section class="p-5 text-start">
                    <ul class="timeline">
                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">
                          1. Business Impact Analysis (BIA):{" "}
                        </h5>

                        <p>
                          Analysieren, welche Geschäftsprozesse und Systeme am
                          kritischsten für das Unternehmen sind und diese im
                          DR-Plan priorisieren. <br /> <br />
                          <ul>
                            <li>
                              <strong>
                                Identifikation von Prozessen und Systemen:{" "}
                              </strong>
                              Alle Geschäftsprozesse und deren IT-Abhängigkeiten
                              werden aufgelistet. Dabei werden sowohl interne
                              Abläufe als auch kundenbezogene Prozesse
                              berücksichtigt, einschließlich der unterstützenden
                              IT-Systeme.
                            </li>{" "}
                            <br />
                            <li>
                              <strong>
                                Analyse kritischer Abhängigkeiten:{" "}
                              </strong>
                              Es wird bewertet, welche Systeme und Anwendungen
                              für die Funktionsfähigkeit jedes Prozesses
                              unerlässlich sind. Ein Online-Shop benötigt
                              beispielsweise ein funktionierendes Backend, eine
                              Datenbank und ein Zahlungssystem.
                            </li>{" "}
                            <br />
                            <li>
                              <strong>Bewertung der Auswirkungen: </strong>
                              Die finanziellen, operativen und regulatorischen
                              Konsequenzen eines Ausfalls werden ermittelt.
                              Zusätzlich wird der potenzielle Reputationsverlust
                              berücksichtigt, insbesondere bei kundenbezogenen
                              Prozessen.
                            </li>
                          </ul>
                        </p>
                      </li>

                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">
                          2. Recovery Time Objective (RTO) und Recovery Point
                          Objective (RPO):
                        </h5>

                        <p>
                          Definieren, wie schnell Systeme wiederhergestellt
                          werden müssen (RTO) und wie viele Daten verloren gehen
                          dürfen (RPO). Diese Ziele dienen als Grundlage für die
                          Ressourcen- und Maßnahmenplanung.
                          <br /> <br />
                          <ul>
                            <li>
                              <strong>Recovery Time Objective (RTO): </strong>{" "}
                              Die maximale akzeptable Zeit, die ein System oder
                              eine Anwendung benötigt, um wiederhergestellt zu
                              werden, bevor kritische Auswirkungen eintreten.
                            </li>{" "}
                            <br />
                            <li>
                              <strong>Recovery Point Objective (RPO): </strong>{" "}
                              Der maximale Zeitraum, für den Datenverlust
                              akzeptabel ist, gemessen in Minuten, Stunden oder
                              Tagen.
                            </li>
                          </ul>
                        </p>
                      </li>

                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">3. Backup-Strategie: </h5>

                        <p>
                          Eine regelmäßige und automatisierte{" "}
                          <Link to="/3_2#backup" className="icon-link">
                            <svg className="bi" aria-hidden="true">
                              <use xlinkHref="#book"></use>
                            </svg>{" "}
                            Backupstrategie
                          </Link>
                          aufbauen.
                        </p>
                        <ul>
                          <li>
                            <strong>Speicherorte: </strong> Redundante
                            (mehrfache) Speicherlösungen wie Cloud-Backups,{" "}
                            <span
                              data-tooltip-id="tooltip-off"
                              data-tooltip-content="Offsite-Backups sind Sicherungskopien von Daten, die an einem physischen Standort außerhalb des Hauptarbeits- oder Geschäftsortes gespeichert werden. Ziel ist es, die Daten auch bei Vorfällen wie Naturkatastrophen, Diebstahl, Feuer oder anderen lokalen Problemen sicher zu schützen, die den Hauptstandort betreffen könnten."
                              className="custom-tooltip-trigger"
                            >
                              {" "}
                              Offsite-Backups,{" "}
                            </span>{" "}
                            oder physische Speichermedien.
                          </li>
                          <li>
                            <strong>Backup-Typen: </strong>Kombination aus
                            inkrementellen Backups für Effizienz und
                            vollständigen Backups für umfassende
                            Wiederherstellung.
                          </li>
                          <li>
                            <strong>Wiederherstellbarkeit: </strong>Regelmäßige
                            Tests, um sicherzustellen, dass Backups im Ernstfall
                            zuverlässig wiederhergestellt werden können.
                          </li>
                        </ul>
                      </li>

                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">4. Redundanz und Failover: </h5>

                        <p>
                          Redundanz- und{" "}
                          <span
                            data-tooltip-id="tooltip-fail"
                            data-tooltip-content="Failover beschreibt den automatischen Prozess, bei dem ein ausgefallenes System, Netzwerk oder eine Anwendung durch ein redundantes System ersetzt wird, ohne dass der Betrieb unterbrochen wird. Es wird eingesetzt, um Hochverfügbarkeit sicherzustellen und Ausfallzeiten zu minimieren."
                            className="custom-tooltip-trigger"
                          >
                            {" "}
                            Failover -Mechanismen
                          </span>{" "}
                          minimieren Ausfallzeiten und garantieren eine hohe
                          Verfügbarkeit von Systemen.
                        </p>
                        <ul>
                          <li>
                            <strong>Redundanz: </strong>Dupliziere kritische
                            Systeme, Daten oder Komponenten, damit bei einem
                            Ausfall sofort eine Alternative verfügbar ist:
                          </li>
                          <ul>
                            <li>
                              <strong>Hardware-Redundanz: </strong>Doppelte
                              Server, Netzwerkgeräte oder Speichermedien.
                            </li>
                            <li>
                              <strong>Daten-Redundanz: </strong>Replizierte
                              Datenbanken oder Speicherlösungen in verschiedenen
                              geografischen Regionen.
                            </li>
                            <li>
                              <strong>Netzwerkredundanz: </strong>Nutzung
                              mehrerer Internetanbieter oder redundanter
                              Netzwerkknoten, um Verbindungsunterbrechungen zu
                              vermeiden.
                            </li>
                          </ul>

                          <li>
                            <strong>Failover:</strong>Automatische Umschaltung
                            auf ein redundantes System bei einem Ausfall:
                          </li>
                          <ul>
                            <li>
                              <strong>Hot Failover:</strong> Die redundante
                              Instanz läuft parallel und übernimmt bei einem
                              Fehler nahtlos.
                            </li>
                            <li>
                              <strong>Cold Failover: </strong>Die redundante
                              Instanz wird erst bei einem Fehler aktiviert, was
                              längere Umschaltzeiten erfordert.
                            </li>
                          </ul>
                        </ul>
                      </li>

                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">5. Testen und Aktualisieren:</h5>

                        <p>
                          Ein Disaster-Recovery-Plan bleibt nur dann effektiv,
                          wenn er regelmäßig getestet und aktualisiert wird.
                        </p>
                        <ul>
                          <li>
                            <strong>Tests:</strong>Katastrophenszenarien werden
                            simuliert, um Schwachstellen im Plan aufzudecken und
                            die Funktionalität aller Systeme, Backups und
                            Prozesse zu überprüfen.
                          </li>
                          <li>
                            <strong>Aktualisierung:</strong>Der Plan wird an
                            technologische, organisatorische oder geschäftliche
                            Veränderungen angepasst. Alle Aktualisierungen
                            werden dokumentiert, um sicherzustellen, dass die
                            beteiligten Teams auf dem neuesten Stand sind.
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </section>
                </p>
                <ReactTooltip
                  id="tooltip-off"
                  place="top"
                  className="custom-tooltip"
                />
                <ReactTooltip
                  id="tooltip-fail"
                  place="top"
                  className="custom-tooltip"
                />
              </Element>
              <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                <img
                  src="/images/fact.svg"
                  alt="Transparent"
                  style={{
                    position: "relative",
                    maxWidth: "8%",
                    height: "auto",
                  }}
                />
                Unternehmen, die ihre Incident-Response- und
                Disaster-Recovery-Pläne regelmäßig testen, berichten von einer
                40% schnelleren Wiederherstellungszeit im Ernstfall.
              </p>
            </div>
          </div>

          <div className="container">
            <div
              className="safe rounded-2 text-center"
              style={{ backgroundColor: "#fec748" }}
            >
              <img
                src="/images/abwehr.svg"
                alt="Abwehr"
                style={{
                  position: "relative",
                  maxWidth: "7%",
                  height: "auto",
                }}
              />
              <h3 className="pt-5 pb-3">
                Incident Response Plan für Unternehmen
              </h3>
              <div className="container pb-5">
                <div className="col-lg-8 mx-auto">
                  <IncidentResponsePlan />
                </div>
              </div>
              <h3 className="pt-5">Disaster Recovery Checklist</h3>
              <div className="container p-3">
                <div className="col-lg-8 mx-auto">
                  <DisasterRecoveryChecklist />
                </div>
              </div>
            </div>
          </div>
          {/* Fragenteil */}
          <div className="container pt-5 my-5">
            <div className="text-center m-4">
              <h2>Überprüfe dein Wissen</h2>
              <p className="col-lg-11 mx-auto">
                Mit den richtigen Antworten kommst du weiter!
              </p>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-8 text-start">
                <form onSubmit={handleSubmit}>
                  {questions.map((question, index) => (
                    <div key={index} className="mb-4">
                      <p className="fs-4">{question.question}</p>{" "}
                      {question.options.map((option) => (
                        <div key={option.value} className="form-check">
                          <input
                            className="form-check-input me-2"
                            type="radio"
                            name={`question${index}`}
                            value={option.value}
                            checked={selectedAnswers[index] === option.value}
                            onChange={() =>
                              handleAnswerChange(index, option.value)
                            }
                          />
                          <label className="form-check-label fs-5">
                            {option.label}
                          </label>{" "}
                        </div>
                      ))}
                    </div>
                  ))}
                  {error && <p className="text-danger">{error}</p>}
                  <div className="text-center">
                    <button type="submit" className="btn btn-primary">
                      überprüfen
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {/* Ende Fragenteil */}
        </div>
      </div>
    </div>
  );
};

export default Chapter4_5;
